import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-locations',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.css']
})
export class LocationsComponent implements OnInit {
// Footer style
classname = "ct-footer footer-dark";
ftlogo = "assets/img1/logo.png"
  constructor() { }

  ngOnInit(): void {
  }

}
